import { render, staticRenderFns } from "./DispensingInHospitalComponent.vue?vue&type=template&id=bd929dac"
import script from "./DispensingInHospitalComponent.vue?vue&type=script&lang=js"
export * from "./DispensingInHospitalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports